import React, {useEffect, useRef} from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import SvgFrame from './features/svg-container/SvgFrame';
import MainFrame from './features/main-frame/MainFrame';
import Error404 from './features/error-404/Error404';
import ErrorPermissionDenied from './features/error-permission/ErrorPermissionDenied';
import NotifyPasswordUpdate from './features/notify/NotifyPasswordUpdate';
import NotifyPermissionUpdate from './features/notify/NotifyPermissionUpdate';
import AuthComponent from './features/auth/AuthComponent';
import {
  selectCurrentGlobalMsg,
  removeCurrentGlobalMsg,
} from './redux/slices/MessageSlice';

import Login from './modules/login/LoginPage';
import {MessageModal} from './components/modal/MessageModal';
import {useSelector, useDispatch} from 'react-redux';

/**
 *
 */
function App() {
  const msgRef = useRef(null);
  const currentGlobalMsg = useSelector(selectCurrentGlobalMsg);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(removeCurrentGlobalMsg());
  };

  useEffect(() => {
    if (
      currentGlobalMsg &&
      msgRef.current &&
      msgRef.current instanceof HTMLElement
    ) {
      // Initialize and show the modal
      msgRef.current = new bootstrap.Modal(msgRef.current);
      msgRef.current.show();
    }
  }, [currentGlobalMsg, dispatch]);

  return (
    <Router>
      <SvgFrame />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/module/*"
          element={
            <AuthComponent>
              <MainFrame />
            </AuthComponent>
          }
        />
        <Route path="/permission-denied" element={<ErrorPermissionDenied />} />
        <Route
          path="/notify-password-update"
          element={<NotifyPasswordUpdate />}
        />
        <Route
          path="/notify-permission-update"
          element={<NotifyPermissionUpdate />}
        />
        <Route path="*" element={<Error404 />} />
      </Routes>
      {currentGlobalMsg && (
        <MessageModal
          ref={msgRef}
          mode={currentGlobalMsg.mode}
          title={currentGlobalMsg.title}
          message={currentGlobalMsg.message}
          isDisabled={currentGlobalMsg.disabled}
          onClose={handleModalClose}
        />
      )}
    </Router>
  );
}

export default App;
